import { render, staticRenderFns } from "./MapPopup.vue?vue&type=template&id=206e297f&"
import script from "./MapPopup.vue?vue&type=script&lang=js&"
export * from "./MapPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports